import { RankedMetric } from '@features/rankings/models/ranking.model'
import { ContextMenuHolder } from '@core/models/context-menu.models'
import { roundJustDecimals } from '@core/utils/number.utils'

export const parseCommonRankingRow = (metric: RankedMetric, metricContext: ContextMenuHolder): RankedMetric => {
  let photoUrl = metric.photoUrl
  let rank: string | number
  let name = metric.name
  const isCompetition = metric.name === 'competition'
  if (isCompetition) {
    rank = '#'
    name = metricContext?.competition?.officialName
    photoUrl = metricContext?.competition?.isoTypeLogo
  } else {
    rank = metric.ranking
  }
  return {
    ...metric,
    rank,
    name,
    photoUrl,
    isCompetition,
    metricValue: roundJustDecimals(metric.metricValue as number)
  }
}
